<template>
  <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
    <h2 class="heading bottom40 darkcolor font-light2">
      <span class="font-normal">Login</span>
      <span class="divider-center"></span>
    </h2>
    <div class="col-md-8 offset-md-2 heading_space">
      <p>
        <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        explicabo laudantium, omnis provident quam reiciendis voluptatum? -->
      </p>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow">
    <b-overlay :show="loadingCard" rounded="sm">
      <div class="widget logincontainer">
        <h3 class="darkcolor bottom35 text-center text-md-left">
          Masuk ke Akun anda
        </h3>
        <Form
          class="getin_form border-form"
          id="login"
          :validation-schema="schema"
          @submit="submitLogin"
        >
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom35">
                <label for="registerEmail" class="d-none"></label>
                <Field
                  class="form-control"
                  type="email"
                  placeholder="Email:"
                  name="email"
                  style="margin: 0px !important"
                  v-model="loginData.email"
                />
                <ErrorMessage class="text-danger" name="email" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom35">
                <label for="registerPass" class="d-none"></label>
                <div
                  class="input-group"
                  style="border: 0px !important; cursor: pointer"
                >
                  <Field
                    type="password"
                    name="password"
                    id="password"
                    class="form-control"
                    placeholder="Password"
                    v-model="loginData.password"
                    style="margin: 0px !important"
                  />
                  <div
                    class="input-group-append"
                    @click="togglePasswordVisibility"
                  >
                    <span class="input-group-text">
                      <i class="fas fa-eye" id="password-toggle"></i>
                    </span>
                  </div>
                </div>
                <ErrorMessage class="text-danger" name="password" />
              </div>
            </div>

            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25 text-center">
                <div class="d-flex w-100 justify-content-center">
                  <RecaptchaV2
                    @widget-id="handleWidgetId"
                    @error-callback="handleErrorCalback"
                    @expired-callback="handleExpiredCallback"
                    @load-callback="handleLoadCallback"
                    language="id"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12">
              <a href="/forgot-password" class="defaultcolor mb-2" style="float: right"
                >Lupa Password ?</a
              >

              <button type="submit" class="button gradient-btn w-100">
                Masuk
              </button>
              <p class="top20 log-meta">
                Belum Memiliki akun ? &nbsp;<a
                  href="/register"
                  class="defaultcolor"
                  >Daftar</a
                >
              </p>
            </div>
            <div class="col-md-8 col-xs-12">

            </div>
            <div class="col-sm-4 col-md-4 col-xs-12">
              <span class="fs-7">Didukung Oleh :</span>
               <img src="img/bsre.png" style="width:130px" class="mt-2" alt="">
            </div>
            
          </div>
        </Form>
      </div>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthStore } from "@/store/auth";
import { useToast, TYPE } from "vue-toastification";
import JwtService from "@/core/services/JwtService";
import { redirectAdmin } from "@/core/helpers/urls";
import { useRoute } from "vue-router";
import router from "@/router";
import CryptoJS from 'crypto-js';

export default defineComponent({
  name: "LoginView",
  components: {
    Form,
    Field,
    ErrorMessage,
    RecaptchaV2,
  },
  setup() {
    const authStore = useAuthStore();
    const loadingCard = ref(false);
    const toast = useToast();
    const route = useRoute();

    const loginData: any = reactive({
      email: "",
      password: "",
      recaptcha_token: "",
    });

    const schema = yup.object({
      email: yup
        .string()
        .required((data) => `Email tidak boleh kosong !`)
        .email((data) => `Email tidak valid !`),
      password: yup
        .string()
        .required("Password tidak boleh kosong !")
        .min(8, "Password minimal 8 karakter")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/,
          "Password harus mengandung huruf besar (A-Z), huruf kecil (a-z), angka (0-9), dan karakter spesial (!@#$%^&*)"
        ),
    });

    const handleWidgetId = (widgetId: number) => {
      // console.log("Widget ID: ", widgetId);
    };
    const handleErrorCalback = () => {
      // console.log("Error callback");
      loginData.recaptcha_token = "";
    };
    const handleExpiredCallback = () => {
      // console.log("Expired callback");
      loginData.recaptcha_token = "";
    };
    const handleLoadCallback = (response: unknown) => {
      // console.log("Load callback", response);
      loginData.recaptcha_token = response;
    };

    const togglePasswordVisibility = () => {
      const password = document.getElementById("password");
      const passwordToggle = document.getElementById("password-toggle");

      if (password && passwordToggle) {
        if (password.getAttribute("type") === "password") {
          password.setAttribute("type", "text");
          passwordToggle.classList.remove("fa-eye");
          passwordToggle.classList.add("fa-eye-slash");
        } else {
          password.setAttribute("type", "password");
          passwordToggle.classList.remove("fa-eye-slash");
          passwordToggle.classList.add("fa-eye");
        }
      }
    };

    const submitLogin = async () => {
      if (loginData.recaptcha_token == "") {
        return;
      }

      authStore.logout();

      const SECRET_KEY = 'kyscrtlogauth26&*';

      // Send login request
      loadingCard.value = true;
      const loginParams: any = {
        email: loginData.email,
        password: CryptoJS.AES.encrypt(loginData.password, SECRET_KEY).toString(),
      };
      await authStore.login(loginParams);
      const error = authStore.errors;
      // console.log(error.constructor);

      if (Object.keys(error).length === 0) {
        toast("Login berhasil", {
          timeout: 5000,
          type: TYPE.SUCCESS,
        });
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
        loadingCard.value = false;
        return;
      }

      if (Array.isArray(error)) {
        const errorObject = error[0] as object;
        const message = Object.values(errorObject)[1] as string;
        if (message == null) {
          console.log(error);
        }

        toast(message, {
          timeout: 5000,
          type: TYPE.ERROR,
        });
      } else {
        toast(error, {
          timeout: 5000,
          type: TYPE.ERROR,
        });
      }

      loadingCard.value = false;
    };

    onMounted(() => {
      if (route.query.logout) {
        authStore.logout();
        window.location.href = "/login";
      }

      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
      }
    });

    return {
      loginData,
      loadingCard,
      authStore,
      toast,
      handleWidgetId,
      handleExpiredCallback,
      handleLoadCallback,
      handleErrorCalback,
      schema,
      togglePasswordVisibility,
      submitLogin,
    };
  },
});
</script>
